import './navbar.scss';

import { useEffect } from 'react';
import { useLocation } from 'react-router';

import { AdminNavBar } from '@/AdminPanel/shared/widgets';
import { DoubleLeftOutlined } from '@/media/antd-icons';
import Logo from '@/media/logo.svg?react';
import { WIDTH_FOR_OPENED_NAVBAR } from '@/shared/constants';
import { useWindowSize } from '@/shared/hooks/useWindowSize';
import { ADMIN_ROUTES, ROUTES } from '@/shared/routes';
import { LocalizedNavLink } from '@/shared/ui';
import { useAppDispatch, useAppSelector } from '@/store';
import { setSidebarExpanded } from '@/store/user-info.slice';

const Navbar: React.FC = () => {
  const location = useLocation();
  const dispatch = useAppDispatch();

  const { menu, isSidebarExpanded } = useAppSelector((state) => state.userInfo);

  const [windowWidth] = useWindowSize();

  const isAdminRoute = location.pathname.includes(ADMIN_ROUTES.root);

  const onClick = () => {
    if (windowWidth < WIDTH_FOR_OPENED_NAVBAR)
      dispatch(setSidebarExpanded(false));
  };

  useEffect(() => {
    if (windowWidth !== 0 && !isAdminRoute) dispatch(setSidebarExpanded(false));
    else if (windowWidth !== 0 && isAdminRoute)
      dispatch(setSidebarExpanded(windowWidth > WIDTH_FOR_OPENED_NAVBAR));
  }, [windowWidth, location.pathname]);

  return (
    <>
      <div
        onClick={() => dispatch(setSidebarExpanded(false))}
        className={`navbar-overlay ${isSidebarExpanded ? 'navbar-overlay--shown' : ''}`}
      ></div>
      <aside
        className={`navbar ${
          isSidebarExpanded ? 'navbar--expanded' : 'navbar--collapsed'
        } ${isAdminRoute ? 'navbar--admin' : ''}`}
      >
        <div className="navbar__logo-box">
          <LocalizedNavLink className="navbar__logo" to={ROUTES.home}>
            <Logo />
          </LocalizedNavLink>
          <button
            className="navbar__arrow"
            onClick={() => dispatch(setSidebarExpanded(!isSidebarExpanded))}
          >
            <DoubleLeftOutlined />
          </button>
        </div>

        <nav className="navbar__navigation-box">
          {isAdminRoute ? (
            <AdminNavBar isSidebarExpanded={isSidebarExpanded} />
          ) : (
            menu.map((element, index) => {
              const isMainPage = element.code === 'main';
              const isActive =
                (isMainPage && location.pathname === ROUTES.home) ||
                location.pathname.includes(element.code);
              const href = isMainPage ? ROUTES.home : `/${element.code}`;

              const linkClasses = [
                'navbar__link',
                isMainPage ? 'navbar__link--main-page' : '',
                !isMainPage && index === 0 ? 'navbar__link--margin-top' : '',
                isActive ? 'navbar__link--active' : ''
              ].join(' ');

              return (
                <LocalizedNavLink
                  to={href}
                  className={linkClasses}
                  onClick={onClick}
                  key={element.uuid}
                >
                  <img
                    className="navbar__link-icon"
                    src={element.icon}
                    alt="setting_icon"
                  />
                  <span className="navbar__link-text">{element?.name}</span>
                </LocalizedNavLink>
              );
            })
          )}
        </nav>
      </aside>
    </>
  );
};

export default Navbar;
